export default "__VITE_ASSET__97bc154f__"